<template>
  <div class="layout-container" id="nipponia-web-layout-container">
    <div class="layout-header-row">
      <Header />
    </div>
    <div class="layout-content-row">
      <div class="sidebar">
        <sideBar></sideBar>
      </div>
      <div class="layout-main--outer" :style="addEnvBg">
        <tab-bar></tab-bar>
        <div class="layout-main">
          <keep-alive v-show="!isMicroApp">
            <router-view class="take"></router-view>
          </keep-alive>
          <div
            :id="item.id"
            class="microapp-container"
            :class="[getcurrentActive(item)]"
            v-for="item in currentMicroApps"
            :key="item.id"
            v-show="isMicroApp"
          ></div>
          <iframe
            v-for="i in loadExternalApps"
            :key="i.id"
            class="external-app"
            v-show="isShow($route.path.slice(1), i.pageUrl)"
            :src="i.pageUrl"
          ></iframe>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import Header from './components/Header'
import TabBar from './components/TabBarNav'
//import FooterBar from './components/FooterBar.vue'
import { isMicroApp } from '@/config/microAppConfig.js'
import sideBar from './components/sideBar'
export default {
  name: 'Layout',
  components: {
    Header,
    TabBar,
    //FooterBar,
    sideBar,
  },
  mounted() {},
  data() {
    return {
      listcount: 0,
      isIframeWebApp: true,
      currentActive: '',
    }
  },
  computed: {
    ...mapState(['loadExternalApps', 'currentMicroApps', 'pcCommonData']),
    ...mapGetters(['getIframeWebAppTabs']),
    addEnvBg() {
      const env = this.pcCommonData.platApp?.env
      if (env && typeof env === 'object' && env.type === 'test') {
        return {
          background: 'url( ' + require('assets/img/testEnvBg.png') + ')',
        }
      }
      return ''
    },
  },
  methods: {
    getPurePath(path) {
      // 获取纯路径，去掉查询参数和哈希
      return path ? path.split('?')[0].split('#')[0] : ''
    },
    isShow(routePath, itPath) {
      const isHttps = routePath.startsWith('https')
      const re = /^http(s)?:\/(\/)?/
      const realRoutePath = routePath.replace(
        re,
        isHttps ? 'https://' : 'http://'
      )
      return this.getPurePath(routePath) === this.getPurePath(itPath)
    },
    getcurrentActive(app) {
      const appq = '/' + this.$route.path.split('/')[1]
      const find = appq === app.activeRule
      if (find) {
        return 'currentActive'
      }
      return ''
    },
    isMicroApp() {
      // 先判断是否是iframe web app
      return isMicroApp(this.$route.path)
    },
  },
}
</script>

<style lang="less">
.layout-container {
  height: 100%;
  .layout-header-row {
    display: flex;
    flex-direction: row;
    align-items: stretch;
  }
}

.layout-main-wrapper {
  display: flex;
  height: calc(100% - 34px);
}
.layout-content-row {
  display: flex;
  flex-direction: row;
  height: calc(100% - 64px);
}
.sidebar {
  width: 64px;
  background: #191a23;
  min-height: 60px;
  //border-radius: 12px 0 0 12px;
  box-shadow: none;
  flex-shrink: 0;
  height: 100%;
  // height: calc(100% - 68px);
}
.sidebar-tool {
  width: 30px;
  height: 30px;
  margin-bottom: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #e0e3eb;
  border-radius: 8px;
  overflow: hidden;
}

.layout-main {
  background: #fff;
  border-radius: 16px;
  overflow: hidden;
  height: calc(100% - 34px);
  margin-bottom: 10px;
}

.layout-main--outer {
  padding: 5px 14px 5px 14px;
  background: #e9edf3;
  height: 100%;
  width: 100%;
}

.currentActive,
.external-app {
  width: -webkit-fill-available;
  height: -webkit-fill-available;
}

.currentActive {
  & > div {
    width: 100%;
    height: 100%;
    overflow: auto;
  }
}
</style>
